<template>
  <div>
    关于本站
  </div>

</template>

<script>
    export default {
        name: "AboutSite"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/AboutSite.vue